import { Directive } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DestroyableComponent } from './destroyable.component';
import { debounceTime, takeUntil } from 'rxjs';
import { Address } from '../models/address/address.model';
import { AltAddress } from '../models/address/alt-address.model';

@Directive()
export class FormComponent extends DestroyableComponent {
	form: FormGroup;
	showErrors: boolean = false;

	getFormData(): any {
		return this.form.value;
	}

	isFormValid(triggerErrors: boolean = true): boolean {
		if (triggerErrors) {
			this.showErrors = true;
		}

		return this.form.valid;
	}

	protected controlShouldTriggerValidation(controlName: string, shouldTriggerControlName: string, form: FormGroup = this.form) {
		form
			.get(controlName)
			?.valueChanges.pipe(debounceTime(300), takeUntil(this.destroyed$))
			.subscribe(() => form.get(shouldTriggerControlName)?.updateValueAndValidity());
	}

	protected createAddressGroup(fb: FormBuilder, address?: Address | AltAddress): FormGroup {
		return fb.group({
			street: [address?.street, Validators.required],
			number: [address?.number, Validators.required],
			box: [address?.box],
			postalCode: [address?.postalCode, Validators.required],
			cityName: [address?.cityName, Validators.required],
		});
	}

	protected enableControlWith(name: string, validators: ValidatorFn[], form: FormGroup = this.form) {
		const control = form.get(name);

		control?.setValidators(validators);
		control?.enable();
		control?.updateValueAndValidity();
	}

	protected disableControl(name: string, form: FormGroup = this.form) {
		const control = form.get(name);

		control?.setValue(null);
		control?.clearValidators();
		control?.disable();
		control?.updateValueAndValidity();
	}

	protected setValidatorsOnSwitch(name: string, fn: (value: boolean, form?: FormGroup) => void, form: FormGroup = this.form) {
		const control = form.get(name);

		fn.bind(this)(control?.value, form);

		control?.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((value) => fn.bind(this)(value, form));
	}
}
